import type * as React from 'react';

interface IntlPluralizeProps {
    count: number;
    singular: string;
    plural: string;
    none?: string;
}

/**
 * Pluralize a word.
 * Written as a component for simplicity.
 */
export function IntlPluralize(props: IntlPluralizeProps): React.ReactElement {
    return <>{intlPluralizeString(props)}</>;
}

/**
 * Pluralize a word. We don't actually use Intl.PluralRules because it's not supported in all browsers
 * and it's not worth the extra bundle size for this use case.
 */
export function intlPluralizeString(props: IntlPluralizeProps): string {
    const { count, singular, plural, none } = props;
    switch (count) {
        case 0:
            return none || plural;
        case 1:
            return singular;
        default:
            return plural;
    }
}
